<sc-padding class="no-field-space">
  <ac-property-group propertyKey="tmc-yard.time-sync.enabled">

    <sc-hint-legacy dictionaryKey="tmc-yard.time-sync.ui.time-sync-admin.keys-title"></sc-hint-legacy>
    <ac-string-property propertyKey="tmc-yard.time-sync.shipperId"></ac-string-property>
    <ac-string-property propertyKey="tmc-yard.time-sync.yardKey"></ac-string-property>

    <sc-content-spacer vertical></sc-content-spacer>

    <sc-sub-title><sc-dictionary-label
        dictionaryKey="tmc-yard.time-sync.ui.time-sync-admin.synchronized-details-title"></sc-dictionary-label></sc-sub-title>
    <sc-hint-legacy dictionaryKey="tmc-yard.time-sync.ui.time-sync-admin.synchronized-details-hint"></sc-hint-legacy>

    <ac-boolean-property propertyKey="tmc-yard.time-sync.arrivalDate"></ac-boolean-property>
    <ac-boolean-property propertyKey="tmc-yard.time-sync.completionDate"></ac-boolean-property>
    <ac-boolean-property propertyKey="tmc-yard.time-sync.statusWaiting"></ac-boolean-property>
    <ac-boolean-property propertyKey="tmc-yard.time-sync.statusInProcessing"></ac-boolean-property>
    <ac-boolean-property propertyKey="tmc-yard.time-sync.statusCanceled"></ac-boolean-property>
    <ac-boolean-property propertyKey="tmc-yard.time-sync.statusCompleted"></ac-boolean-property>
    <ac-boolean-property propertyKey="tmc-yard.time-sync.statusPaused"></ac-boolean-property>

  </ac-property-group>

</sc-padding>
